module.exports = __webpack_public_path__ + "0f224bc8edb5e30f08fdabd4f9e7d595.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/lankenau01.jpg
// module id = 798
// module chunks = 0